import Grid from '@mui/material/Grid'

import type { FilterOption, GroupedFilterOption } from '@models/Filter'
import type { Gebied } from '@models/Gebied'

import { SubprocesTypes } from '../../../../entity/subprocessen/types/Subproces'
import { StyledExpandCard } from '../../../../theme/components/StyledExpandCard'
import { useWerklijsten } from '../../hooks/useWerklijsten'

import { SubprocesWerklijstenFilters } from './SubprocesWerklijstenFilters'
import SubprocesTile from './Tile'

interface Props {
  filterOptions: {
    gebieden: Gebied[]
    actiehouders: GroupedFilterOption[]
    labels: FilterOption[]
  }
  onClickTile: (query: any, url: string) => void
}

export const Subprocessen = ({ onClickTile, filterOptions }: Props) => {
  const {
    data: { subprocessen },
    filters,
    initialFilters,
    onChangeFilters,
    onReset,
    onRefresh,
  } = useWerklijsten()

  const groupedCodes: Record<
    string,
    { code: string; count: number; red: number; amber: number; green: number }[]
  > = {}

  // label komt vanuit de backend als het 'type' subproces
  subprocessen.forEach((x) => {
    if (!groupedCodes[x.label]) {
      groupedCodes[x.label] = []
    }

    groupedCodes[x.label].push(x)
  })

  return (
    <>
      <SubprocesWerklijstenFilters
        filters={filters}
        initialFilters={initialFilters}
        onChange={onChangeFilters}
        onRefresh={onRefresh}
        onReset={onReset}
        filterOptions={filterOptions}
      />
      {Object.entries(groupedCodes).map(([type, entries]) => {
        return (
          <StyledExpandCard title={SubprocesTypes[type]} key={type}>
            <Grid container spacing={2}>
              {entries.map(({ code, count, red, amber, green }) => (
                <Grid key={code}>
                  <SubprocesTile
                    type={type}
                    status={code}
                    count={count}
                    red={red}
                    amber={amber}
                    green={green}
                    onClickTile={onClickTile}
                  />
                </Grid>
              ))}
            </Grid>
          </StyledExpandCard>
        )
      })}
    </>
  )
}
